import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-37b32e6a")
const _hoisted_1 = { class: "developerLogin" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "_header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "_headerText" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "_dev" }, "Dev"),
    /*#__PURE__*/_createTextVNode("Login ")
  ])
], -1)
const _hoisted_3 = { class: "_main" }
const _hoisted_4 = {
  key: 0,
  class: "body _loader"
}
const _hoisted_5 = {
  key: 1,
  class: "body"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "_bodyRow _subheader" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Developer's dashboard")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "_bodyRow _subheader" }, [
  /*#__PURE__*/_createElementVNode("p", null, " To make use of the developer's console, you must: "),
  /*#__PURE__*/_createElementVNode("ol", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Be logged in"),
    /*#__PURE__*/_createElementVNode("li", null, "Have developer privileges")
  ])
], -1)
const _hoisted_8 = { class: "buttonRow" }
const _hoisted_9 = {
  key: 2,
  class: "body"
}
const _hoisted_10 = {
  key: 0,
  class: "_loadPrompt"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "You do not have developer permissions.", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, "We are not currently looking for contributors, sorry. Please return to the home screen.", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_14 = { class: "buttonRow" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_LoadSpinner = _resolveComponent("LoadSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.$store.state.Auth.user.unset)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_MovingIcon, {
              name: "loader_spinner",
              loop: true,
              autoplay: true
            })
          ]))
        : (_ctx.$store.state.Auth.user.signedOut)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_IconButton, {
                    text: "Login to begin",
                    colored: true,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/account'})))
                  })
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.$store.state.Auth.user.developer == -1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_LoadSpinner, { text: "Verifying developer status" })
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.Auth.user.developer == false)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_IconButton, {
                        text: "Browse games",
                        colored: true,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/app'})))
                      })
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
    ])
  ]))
}